import StrUtils from '@/utils/StrUtils'
import { Job } from '@/class/model/booking/Job'
import { Company } from '@/class/model/mdm/Company'
import { queryTemplateTypeSchemaType } from '@/api/sysManage/baseConfig/templateType'
import { queryInitTemplateBySchemaType } from '@/api/sysManage/baseConfig/template'
import { cacheName, cache } from '@/utils/cacheManager'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { PrintTemplateManager } from '@/class/cargo/model/utils/PrintTemplateManager'
import { getJobByUuid } from '@/api/booking/job'
import checkPermission from '@/utils/permission'
import { WarehouseIn } from '@/class/model/booking/WarehouseIn'
import $store from '@/store'
import { BillPayment } from '@/class/model/act/BillPayment'
import * as CommonUtil from '@/utils/commonUtil'
import { v3ReportExport } from '@/api/v3Report'
import { createPrintTask, downloadPrintTaskResult, getPrintTask } from '@/api/report/printTaskV2'
import { PrintTaskV2RequestBuilder } from '@/class/cargo/model/print/PrintTaskV2RequestBuilder'
import { PrintTaskPoller } from '@/class/cargo/model/print/PrintTaskPoller'
import { PrintResultDownloader } from '@/class/cargo/model/print/PrintResultDownloader'
import { getPrintTaskClientModeValue } from '@/utils/printTaskMode'
import UIDUtil from '@/utils/uidUtil'
import { Invoice } from '@/class/model/act/Invoice'

export class StimulSoftUtil {
  /**
   * Report Service URL
   */
  static SERVICE_URL = 'http://192.168.20.26/WalltechReport/'

  /**
   * JasperReport
   */
  static JASPERREPORT = 0

  /**
   * StiReport
   */
  static StiReport = 1

  /**
   * V3
   */
  static V3 = 2

  /**
   * 打印过程提示回调。
   */
  static printOptions = {}

  /**
   * instance
   */
  static instance

  /**
   * 创建
   */
  static STIREPORT_CREATE = 0

  /**
   * 预览
   */
  static STIREPORT_VIEW = 1

  /**
   * constructor
   */
  constructor() {
    this.template = {}
    this.templateType = {}
    this.entity = {}
    this.param = {}
    this.templateName = ''
    this.displayMode = null // 显示模式 0.创建 1.预览
    this.exportType = '' // 导出类型
    // CARGO-1929，V2V3模板直发邮件能根据接收方类型自动取邮件地址
    this.email_to = ''
    this.email_cc = ''
    this.email_title = ''
    this.email_content = ''
    //
    this.documentType = null
    this.user = {}
    this.officeId = 0
  }

  /**
   * singleton
   */
  static getInstance() {
    if (!this.instance) {
      this.instance = new StimulSoftUtil()
    }
    return this.instance
  }

  /**
   * @private
   */
  static isOpenStiReport(template) {
    return !StrUtils.isEmpty(template.documentId) && (Number(template.engine) === this.StiReport || Number(template.engine) === this.V3)
  }

  /**
   * 新报表
   */
  static async stiReportPreview(template, entity = null, param = null, displayMode = 1, exportType = '', printOptions = {}) {
    await cache.load(cacheName.USER, cacheName.OFFICE, cacheName.CONFIG)
    this.printOptions = printOptions
    this.user = cache.user
    this.officeId = cache.office.officeId

    this.template = template
    this.entity = await this.convertAbstractEntity(entity)
    // console.log('========entity', entity.uuid)
    this.param = param
    this.displayMode = displayMode
    this.exportType = exportType
    this.settlementCenterMode = String(cache.config.get('SettlementCenterMode')) === '1' // 锦昶共享中心
    if (this.param) {
      if (Object.prototype.hasOwnProperty.call(this.param, 'documentType')) {
        this.documentType = this.param['documentType']
      }
      // email_to
      if (Object.prototype.hasOwnProperty.call(this.param, 'email_to')) {
        this.email_to = this.param['email_to']
        delete this.param['email_to']
      }
      // email_cc
      if (Object.prototype.hasOwnProperty.call(this.param, 'email_cc')) {
        this.email_cc = this.param['email_cc']
        delete this.param['email_cc']
      }
      // email_title
      if (Object.prototype.hasOwnProperty.call(this.param, 'email_title')) {
        this.email_title = this.param['email_title']
        delete this.param['email_title']
      }
      // email_content
      if (Object.prototype.hasOwnProperty.call(this.param, 'email_content')) {
        this.email_content = this.param['email_content']
        delete this.param['email_content']
      }
    }
    if (template && template.templateType) {
      const res = await queryTemplateTypeSchemaType(template.templateType)
      return await this.queryTemplateTypeHandler(res)
    }
  }

  /**
   * @private
   */
  static async queryTemplateTypeHandler(res) {
    const temp = res.data
    if (!temp || StrUtils.isEmpty(temp.schemaType)) {
      throw new ErrorTip('SchemaType未维护')
    }
    this.templateType = temp
    if (this.template && this.template.engine === 2) {
      if (this.displayMode === this.STIREPORT_CREATE) {
        await this.createV3()
      } else {
        return await this.previewV3()
      }
    } else {
      if (this.displayMode === this.STIREPORT_CREATE) {
        this.create()
      } else {
        await this.preview()
      }
    }
  }

  /**
   * 新增报表
   */
  static create() {
    const url = cache.config.get('StiReportServerURL') + 'StiRptCreate.aspx'
    const form = {}
    form.USER_ID = this.user.userId
    form.___SESSION_ID = this.user.sessionId
    form.___TEMPLATE_UUID = this.template.uuid
    form.___SCHEMA_TYPE = this.templateType.schemaType || 'null'
    form.___REPORT_PATH = this.user.tenantId
    form.___UPDATE_CLOUD_DOCID_URL = cache.config.get('CargoApiURL') + 'api/external-service/trackingInfo/updateTrackingForDocumentType'
    form.___DESIGN_MODE = checkPermission(['role_template_design']) ? 1 : 0
    form.___UPDATE_PRINTED_STATE_URL = ''
    form.___RECEIVER_EMAIL = this.user.email || ''
    //
    form.___EMAIL_TO = this.email_to || ''
    form.___EMAIL_CC = this.email_cc || ''
    form.___EMAIL_SUBJECT = this.email_title || ''
    form.___EMAIL_CONTENT = this.email_content || ''
    //
    this.refreshVariable(form)
    this.toSubmit(url, form, 'V2新增报表')
  }

  static async createV3() {
    if (this.templateType && this.templateType.schemaType) {
      const res = await queryInitTemplateBySchemaType(this.templateType.schemaType)
      this.queryInitTemplateResultHandler(res)
    }
  }

  /**
   * @private
   */
  static queryInitTemplateResultHandler(res) {
    const result = res.data
    if (!result) {
      throw new ErrorTip('未查询到基础模板信息,请检查模板数据源是否正确！')
    } else {
      // V3设计
      const url = cache.config.get('V3ServerURL') + '/report/designer'
      const form = {}
      form.TEMPALTE_TYPE = this.template.templateType
      form.OFFICE_ID = this.officeId
      form.USER_ID = this.user.userId
      form.sessionId = this.user.sessionId
      form.LANGUAGE = $store.getters.language
      form.TEMPLATE_FILTER = this.template.filter || ''
      form.___SESSION_ID = this.user.sessionId
      form.___TEMPLATE_UUID = this.template.uuid
      form.___SCHEMA_TYPE = this.templateType.schemaType || 'null'
      form.___REPORT_PATH = this.user.tenantId
      form.___UPDATE_CLOUD_DOCID_URL = cache.config.get('CargoApiURL') + 'api/external-service/trackingInfo/updateTrackingForDocumentType'
      form.___DESIGN_MODE = checkPermission(['role_template_design']) ? 1 : 0
      form.___UPDATE_PRINTED_STATE_URL = ''
      form.___RECEIVER_EMAIL = this.user.email
      form.___CLOUD_FILE_EXTATION = null
      form.remarks = this.template.remarks
      form.___STORAGE_FILE_ID = result['storageId'] || ''
      form.___CLOUD_FILE_PREFIX = result['templateName'] || ''
      form.___PARAMSTRS = PrintTemplateManager.toUrlArgs(form) + '&ACT_ACTUAL_AMOUNT_UUID=' + null + '&CHARGE_UUID=' + null + '&DOC_UUID=' + null + '&JOB_UUID=' + null + '&POITEMS_UUID=' + null + '&BILLING_UUID=' + null +
        '&BILL_PAYMENT_UUID=' + null + '&BILL_PAYMENT_UUID_LIST=' + null + '&CONTAINER_UUID=' + null + '&CUSTOMS_INFO_UUID=' + null + '&FILE_UUID=' + null + '&INVOICE_UUID=' + null + '&VOUCHERS_UUID=' + null +
        '&TRUCKING_UUID=' + null + '&COMPANY_UUID=' + null + '&QUOTATION_UUID=' + null + '&SPECIAL_GOOD_UUID=' + null + '&VGM_UUID=' + null + '&WAREHOUSE_UUID=' + null
      form.___CLOUD_FILE_EXTATION = null
      //
      form.___EMAIL_TO = this.email_to || ''
      form.___EMAIL_CC = this.email_cc || ''
      form.___EMAIL_SUBJECT = this.email_title || ''
      form.___EMAIL_CONTENT = this.email_content || ''
      this.refreshVariable(form)
      this.toSubmit(url, form, 'V3设计报表')
    }
  }

  /**
   * 预览
   */
  static async preview() {
    const url = cache.config.get('StiReportServerURL') + 'StiRptPreview.aspx'
    const form = {}
    form.USER_ID = this.user.userId
    form.___SESSION_ID = this.user.sessionId
    form.___TEMPLATE_UUID = this.template.uuid
    form.___SCHEMA_TYPE = this.templateType.schemaType || 'null'
    form.___REPORT_PATH = this.user.tenantId
    form.___UPDATE_CLOUD_DOCID_URL = cache.config.get('CargoApiURL') + 'api/external-service/trackingInfo/updateTrackingForDocumentType'
    form.___REPORT_FILE_ID = this.template.templateFile || 'null'
    form.___CLOUD_FILE_PREFIX = await this.getDownloadFileName()
    form.___CLOUD_FILE_EXTATION = await this.getFileExtation()
    form.___DESIGN_MODE = checkPermission(['role_template_design']) ? 1 : 0
    form.___UPDATE_PRINTED_STATE_URL = this.getPrintCallBackUrl()
    form.___RECEIVER_EMAIL = this.user.email
    //
    form.___EMAIL_TO = this.email_to || ''
    form.___EMAIL_CC = this.email_cc || ''
    form.___EMAIL_SUBJECT = this.email_title || ''
    form.___EMAIL_CONTENT = this.email_content || ''
    //
    this.refreshVariable(form)
    this.toSubmit(url, form, 'V2预览报表')
  }

  /**
   * 提交
   * @param URL
   * @param PARAMS
   * @param type
   */
  static toSubmit(URL, PARAMS, type) {
    PARAMS['zone'] = CommonUtil.requestTimeZone() // 获取当前时区
    console.log(type + ':' + encodeURI(URL) + '=============')
    const form = document.createElement('form')
    form.action = encodeURI(URL)
    form.method = 'post'
    form.style.display = 'none'
    let msg = '=============' + type + 'post参数=============\n'
    for (const key in PARAMS) {
      const opt = document.createElement('textarea')
      opt.name = key
      opt.value = PARAMS[key]
      form.appendChild(opt)
      msg += `${opt.name}: ${opt.value}\n`
    }
    console.log(msg + '=============END=============')
    form.target = '_blank'
    document.body.appendChild(form)
    form.submit()
  }

  static getFileExtation() {
    const ctx = this.entity
    let extation = ''
    if (ctx) {
      if (ctx instanceof Job || ctx.lob) {
        if (ctx instanceof WarehouseIn && ctx.fba) {
        } else {
          extation = 'jobNo=' + (ctx.jobNo || '')
          if (ctx.mbl) {
            extation += '&mbl=' + encodeURIComponent(ctx.mbl)
          }
        }
      } else if (ctx instanceof Company) {
        extation = 'companyKey=' + encodeURIComponent(ctx.uuid || '')
      } else if (ctx instanceof BillPayment && ctx.currentJobNo) {
        extation = 'jobNo=' + (ctx.currentJobNo || '')
      } else if (ctx instanceof Invoice) {
        // 开启锦昶参数，
        if (this.settlementCenterMode) {
          // 添加下面参数会使发票在V3打印后,生成的附件在发票附件页签展示
          // settlementCenterMode 用于自动推送共享中心 锦昶专用
          extation = 'invoiceUuid=' + (ctx.uuid || '') + '&settlementCenterMode=1'
        }
      }
    }
    if (this.template && Number(this.template.engine) === this.V3 && this.param) {
      if (this.param.hasOwnProperty('hblNo')) {
        extation += '&hblNo=' + this.param.hblNo || ''
      }
      if (this.param.hasOwnProperty('hblRefNo')) {
        extation += '&hblRefNo=' + this.param.hblRefNo || ''
      }
      if (this.param.hasOwnProperty('subBill')) {
        extation += '&subBill=' + this.param.subBill || 0
      }
      if (this.param.hasOwnProperty('subBillUuid')) {
        extation += '&subBillUuid=' + this.param.subBillUuid || ''
      }
    }
    // 上传业务文件历史参数(应用于非基本页签打印，其他页签打印)
    if (this.param && this.param.hasOwnProperty('uploadJobFileHistoryParam') && this.param.uploadJobFileHistoryParam && this.param.uploadJobFileHistoryParam) {
      for (const key in this.param.uploadJobFileHistoryParam) {
        const item = this.param.uploadJobFileHistoryParam[key]
        if (extation.length > 0) {
          extation += '&'
        }
        extation += key + '=' + item
      }
    }
    extation = this.handlerCommonParam(extation)
    return extation
  }

  static handlerCommonParam(extation = '') {
    if (extation.length > 0) {
      extation += '&'
    }
    let documentType = 'OTHER'
    let destinationAgent = 'false'
    let op = 'false'
    let sales = 'false'
    let cargoSales = 'false'
    let csr = 'false'
    let overseaOp = 'false'
    let dc = 'false'
    let planner = 'false'
    let isShared = 'false'
    let all = ''
    let customer = 'false'
    let consignee = 'false'
    let shipper = 'false'
    let bookingAgent = 'false'
    let userDefinedRoleId1 = 'false'
    let userDefinedRoleId2 = 'false'
    if (this.documentType) {
      documentType = this.documentType.code
      destinationAgent = this.documentType.destinationAgent
      op = this.documentType.op
      sales = this.documentType.sales
      cargoSales = this.documentType.cargoSales
      csr = this.documentType.csr
      overseaOp = this.documentType.overseaOp
      dc = this.documentType.dc
      planner = this.documentType.planner
      isShared = this.documentType.shared
      all = this.documentType.other
      customer = this.documentType.customer
      consignee = this.documentType.consignee
      shipper = this.documentType.shipper
      bookingAgent = this.documentType.bookingAgent
      userDefinedRoleId1 = this.documentType.userDefinedRoleId1
      userDefinedRoleId2 = this.documentType.userDefinedRoleId2
    }
    const jobKey = this.getJobKey()
    extation += 'uuid=' + encodeURIComponent(jobKey || (this.exportType ? UIDUtil.createUID() : '')) + '&documentType=' + documentType + '&createdBy=' + this.user.userId +
        '&destinationAgent=' + destinationAgent + '&op=' + op + '&sales=' + sales + '&isShared=' + isShared +
        '&cargoSales=' + cargoSales + '&csr=' + csr + '&overseaOp=' + overseaOp + '&dc=' + dc + '&planner=' + planner +
        '&all=' + all + '&customer=' + customer + '&consignee=' + consignee + '&shipper=' + shipper + '&bookingAgent=' + bookingAgent +
        '&userDefinedRoleId1=' + userDefinedRoleId1 + '&userDefinedRoleId2=' + userDefinedRoleId2
    return extation
  }
  /**
   * 打印回调URL
   */
  static getPrintCallBackUrl() {
    let printCallBackUrl = ''
    if (this.param.printCallBackUrl) {
      printCallBackUrl = this.param.printCallBackUrl
    }
    const jobKey = this.getJobKey()
    if (jobKey != null && this.documentType) {
      if (printCallBackUrl.length > 0) {
        printCallBackUrl += '&jobKey=' + encodeURIComponent(jobKey) + '&documentTypeKey=' + encodeURIComponent(this.documentType.uuid)
      } else {
        printCallBackUrl = 'services/printExec/template/V2/printed/changeSopState?jobKey=' + encodeURIComponent(jobKey) + '&documentTypeKey=' + encodeURIComponent(this.documentType.uuid)
      }
    }
    if (printCallBackUrl) {
      printCallBackUrl = cache.config.get('CargoApiURL') + printCallBackUrl
      printCallBackUrl = printCallBackUrl.replace('services/', 'services/apiMove/cargo/v2/')
      // CARGO-25946，打印后发送文件信息
      if (Number(cache.config.get('ToExoSystem')) === 2) printCallBackUrl += '&toExoSystemOC=true'
      return printCallBackUrl
    } else {
      return ''
    }
  }

  static getJobKey() {
    if (this.entity) {
      // if (_entity is Job)
      //   return _entity.key;
      // else if (_entity is CargoDoc)
      //   return CargoDoc(_entity).job.key;
      // else if (_entity is TruckingInfo)
      //   return TruckingInfo(_entity).job.key;
      // else if (_entity is WarehouseInfo)
      //   return WarehouseInfo(_entity).job.key;
      // else if (_entity is Charge)
      //   return Charge(_entity).job.key;
      // else if ((_entity is Billing) && Billing(_entity).job)
      //   return Billing(_entity).job.key
      if (this.entity instanceof Job) {
        return this.entity.uuid
      } else if (this.entity instanceof WarehouseIn && this.entity.fba) {
        return this.entity.uuid
      } else {
        return this.entity.jobUuid ? this.entity.jobUuid : this.entity.uuid
      }
    }
    return null
  }

  /**
   * 动态获取参数
   */
  static refreshVariable(form) {
    for (const key in this.param) {
      if (key === 'printCallBackUrl' || key === 'printSource' || key === 'uploadJobFileHistoryParam') {
        continue
      }
      const item = this.param[key]
      if (Array.isArray(item)) {
        let arrStr = ''
        for (const str of item) {
          if (arrStr) {
            arrStr += ','
          }
          arrStr = `${arrStr}'${str}'`
        }
        form[key] = arrStr
      } else {
        form[key] = `'${item}'`
      }
      if (Object.prototype.hasOwnProperty.call(form, 'jobuuid') && !Object.prototype.hasOwnProperty.call(form, 'JOB_UUID')) {
        form['JOB_UUID'] = form['jobuuid']
      }
    }
  }

  // V3预览
  static async previewV3() {
    const form = {}
    form.ACTION = 'view'
    form.TEMPALTE_TYPE = this.template.templateType
    form.OFFICE_ID = this.officeId
    form.USER_ID = this.user.userId
    form.TENANT_ID = this.user.tenantId
    form.sessionId = this.user.sessionId
    form.printSource = this.param.printSource || ''
    form.LANGUAGE = $store.getters.language
    form.TEMPLATE_FILTER = this.template.filter || ''
    form.___SESSION_ID = this.user.sessionId
    form.___TEMPLATE_UUID = this.template.uuid
    form.___SCHEMA_TYPE = this.templateType.schemaType || 'null'
    form.___REPORT_PATH = this.user.tenantId
    form.___UPDATE_CLOUD_DOCID_URL = cache.config.get('CargoApiURL') + 'api/external-service/trackingInfo/updateTrackingForDocumentType'
    form.___REPORT_FILE_ID = this.template.templateFile || 'null'
    form.___CLOUD_FILE_PREFIX = await this.getDownloadFileName()

    form.___DESIGN_MODE = checkPermission(['role_template_design']) ? 1 : 0
    form.___UPDATE_PRINTED_STATE_URL = this.getPrintCallBackUrl()
    form.___RECEIVER_EMAIL = this.user.email
    form.___STORAGE_FILE_ID = this.template.documentId || ''
    form.remarks = this.template.remarks
    //
    form.___EMAIL_TO = this.email_to || ''
    form.___EMAIL_CC = this.email_cc || ''
    form.___EMAIL_SUBJECT = this.email_title || ''
    form.___EMAIL_CONTENT = this.email_content || ''
    await this.refreshVariable(form)
    form.___PARAMSTRS = await PrintTemplateManager.toUrlArgs2(form, this.template)
    form.___CLOUD_FILE_EXTATION = await this.getFileExtation()
    if (this.exportType) {
      form.exportType = this.exportType
      form.templateName = this.template.name
      form['zone'] = CommonUtil.requestTimeZone() // 获取当前时区
      if (PrintTaskV2RequestBuilder.isLegacyEnabled(
        getPrintTaskClientModeValue(),
        process.env.VUE_APP_REPORT_PRINT_API_VERSION
      )) {
        return await v3ReportExport(form)
      }
      return await this.exportWithPrintTaskV2(form)
    } else {
      const url = cache.config.get('V3ServerURL') + '/report/view'
      this.toSubmit(url, form, 'V3预览报表')
    }
  }

  /**
   * @private
   */
  static async exportWithPrintTaskV2(form) {
    const request = PrintTaskV2RequestBuilder.build({
      template: this.template,
      templateType: this.templateType,
      form,
      exportType: this.exportType,
      sourcePage: window.location.pathname,
      printSource: form.printSource
    })
    const poller = new PrintTaskPoller({ createPrintTask, getPrintTask })
    const task = await poller.run(request, {
      onProgress: this.printOptions && this.printOptions.onProgress
    })
    if (task.status !== 'SUCCEEDED') {
      const error = new Error(task.errorMsg || `Print task ${task.status}`)
      error.printTask = task
      throw error
    }
    if (this.printOptions && this.printOptions.onProgress) {
      this.printOptions.onProgress(task)
    }
    const downloader = new PrintResultDownloader(downloadPrintTaskResult)
    await downloader.open(task)
    const result = downloader.toLegacyFileResult(task)
    result.downloaded = true
    return result
  }

  /**
   * 获取 ___CLOUD_FILE_PREFIX
   */
  static async getDownloadFileName() {
    // 模板自定义规则
    if (this.param && this.param.templateRuleName) {
      return decodeURI(this.param.templateRuleName)
    }
    const separatorsFlag = this.param && parseInt(this.param.templateSeparators) === 1 ? '-' : '_'
    // CARGO-6000，圣世特：V2模板，国内账单另存文件，文件名需要由模板名称+账单号组成
    if (this.templateType.templateType === 'INTERNALBILLING') { // 国内账单=INTERNALBILLING
      // 配置参数：isInternalBillInfo: 0，表示文件名由模板名称+业务编号构成；1，表示文件名由模板名称+账单号构成；
      const isInternalBillInfo = parseInt(cache.config.get('isInternalBillInfo'))
      if (isInternalBillInfo === 0 && Object.prototype.hasOwnProperty.call(this.param, 'jobNo')) {
        // PrintFileName，模板生成文件名称规则，配置MBLNO/HBLNO，则模板名+MBLNO/HBLNO；默认模板名+JOBNO
        if (this.entity instanceof Job) {
          const fileNameType1 = cache.config.get('PrintFileName')
          const fileNo1 = await this.getPrintNoType(this.entity, fileNameType1)
          return (this.template.name + separatorsFlag + fileNo1)
        }
        return (this.template.name + separatorsFlag + this.param['jobNo'])
      } else if (isInternalBillInfo === 1 && Object.prototype.hasOwnProperty.call(this.param, 'billingNo')) {
        return (this.template.name + separatorsFlag + this.param['billingNo'])
      }
    } else if (this.templateType.templateType === 'US_CLEAR_CUSTOMS_INVOICE') {
      return this.template.name + separatorsFlag + this.param.jobNo
    }

    if (this.entity instanceof Job) {
      const fileNameType = cache.config.get('PrintFileName')
      const fileNo = await this.getPrintNoType(this.entity, fileNameType)
      return (this.template.name + separatorsFlag + fileNo)
    }
    return this.template.name
  }

  static async getPrintNoType(job, fileNameType) {
    let fileNo = job.jobNo
    if (fileNameType === 'HBLNO') {
      const cargoDocs = await new Job(job).getCargoDoc()
      for (const doc of cargoDocs) {
        if (doc.docType === 'HBL') {
          fileNo = doc.hblNbr2
          break
        }
      }
    } else if (fileNameType === 'MBLNO') {
      fileNo = job.mbl
    }
    return fileNo
  }

  /**
   * 获取当前entity对象
   */
  static async convertAbstractEntity(entity) {
    // todo 返回job实体
    // if(entity is SeaCargoDoc)
    // {
    //   return SeaCargoDoc(entity).job;
    // }
    // else if(entity is AirCargoDoc)
    // {
    //   return AirCargoDoc(entity).job;
    // }
    if (entity) {
      const className = entity.className || entity.constructor.name
      if (className === 'SeaCargoDoc' || className === 'AirCargoDoc' || className === 'Vgm' || className === 'UsCustomsClearance' || className === 'SeaImCargoDoc') {
        entity = await getJobByUuid(entity.jobUuid).then(res => {
          const job = res.data
          // console.log('========job', job.uuid, new Job(job).uuid)
          return !job ? entity : new Job(job)
        })
      }
    }
    return entity
  }
}
